// extracted by mini-css-extract-plugin
export default {"wrapper":"CloseTopBar_wrapper__wEUwk"};